module.exports = __webpack_public_path__ + "static/img/jiaying-header.05cac041.png";